import { render } from "./FormatHelper.vue?vue&type=template&id=71372ff8&scoped=true"
import script from "./FormatHelper.vue?vue&type=script&lang=js"
export * from "./FormatHelper.vue?vue&type=script&lang=js"

import "./FormatHelper.vue?vue&type=style&index=0&id=71372ff8&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71372ff8"]])

export default __exports__